/*
 * The english translation of the cooking pot view & the postOnBoardingStore (Tour)
 */
export const COOKING_POT_VIEW_EN = {
  // GeneratedInputPanel.vue
  titlePlaceholder: 'Enter your title here..',
  // CopyToClipboard.ts
  copiedToClipboard: 'Copied to clipboard',
  failedToCopy: 'Failed to copy',
  noInputText: 'No input text provided',
  noFormatsSelectedForGeneration: 'No formats selected for generation.',
  inputTextTooShort: 'Input text must have at least 50 words',
  inputTextTooLong:
    'Input text is too long. Please keep it below three million characters, or roughly 450,000 words.',
  canceledGeneration: 'Generation canceled',
  generating: 'Generating',
  generationCompleted: 'Generation completed!',
  accountCannotPublish: 'Your account can not publish',
  changeInputOrPreferences: 'Change input/preferences to regenerate!',
  characters: 'characters',
  // AI GENERATED
  generationFailed: 'Generation failed. Please try again.',
  editorRateLimitReached: 'Request limit reached. Please try again later.',
  // AI GENERATED
  errorGeneratingTitles: 'Could not generate titles.',
  // AI GENERATED
  headlinePromptNotFound: 'Headline prompt template not found.',
  // AI GENERATED
  socialMediaPromptNotFound: 'Social media prompt template not found.'
}
/*
 * The german translation of the cooking pot view & the postOnBoardingStore (Tour)
 */
export const COOKING_POT_VIEW_DE = {
  // GeneratedInputPanel.vue
  titlePlaceholder: 'Titel hier eingeben...',
  // CopyToClipboard.ts
  copiedToClipboard: 'In Zwischenablage kopiert',
  failedToCopy: 'Kopieren fehlgeschlagen',
  noInputText: 'Kein Eingabetext bereitgestellt',
  noFormatsSelectedForGeneration: 'Keine Formate für die Generierung ausgewählt.',
  inputTextTooShort: 'Eingabetext muss mindestens 50 Wörter enthalten',
  inputTextTooLong:
    'Der Eingabetext ist zu lang. Bitte unter drei Millionen Zeichen oder grob 450.000 Wörtern bleiben.',
  canceledGeneration: 'Generierung abgebrochen',
  generating: 'Generiere',
  generationCompleted: 'Generierung abgeschlossen!',
  accountCannotPublish: 'Ihr Konto kann nicht veröffentlichen',
  changeInputOrPreferences: 'Eingabe/Einstellungen ändern, um neu zu generieren!',
  characters: 'Zeichen',
  // AI GENERATED
  generationFailed: 'Generierung fehlgeschlagen. Bitte erneut versuchen.',
  editorRateLimitReached: 'Anfragelimit erreicht. Bitte später erneut versuchen.',
  // AI GENERATED
  errorGeneratingTitles: 'Titel konnten nicht generiert werden.',
  // AI GENERATED
  headlinePromptNotFound: 'Vorlage für die Überschriften nicht gefunden.',
  // AI GENERATED
  socialMediaPromptNotFound: 'Vorlage für Social-Media-Texte nicht gefunden.'
}
